import { useRef, useState, useEffect, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, } from '@mui/material';

interface MfaVerifyModalProps {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleMfaVerified: () => void;
  handleMfaCancel: () => void;
}

const MfaVerify = ({ 
  isVisible,
  setIsVisible,
  handleMfaVerified, 
  handleMfaCancel 
}: MfaVerifyModalProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [inputStatus, setInputStatus] = useState("");

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const onConfirm = () => {
    const cleanCode = code.replace(/\s+/g, "");
    if (cleanCode === "") {
      setInputStatus("error");
    } else {
      handleMfaVerified();
    }
  };

  const handleCodeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setCode(input);
    if (input !== "") {
      setInputStatus("");
    }
  };

  const handleOnKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  useEffect(() => {
    if (isVisible) {
      setShowModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
      <Dialog
            open={showModal}
            onClose={handleMfaCancel}
            className='opt-google-popup'
            aria-labelledby='dialog-title'
          >
        <DialogTitle id='dialog-title'>
          <Typography className="text-center">{t("confirm_mfa_title")}</Typography>
        </DialogTitle>
        <DialogContent  >
        <p className="py-7">{t("confirm_mfa_disable_instruction")}</p>
          <strong className="mr-2">{t("google_opt_code")}:</strong>
          
          <TextField
            placeholder={t("google_opt_code")}
            inputProps={{ maxLength: 16 }}
            variant="outlined"
            size="small"
            error={inputStatus === "error"}
            helperText={inputStatus === "error" ? t("mfa_required") : ""}
            onChange={handleCodeInput}
            onKeyDown={handleOnKeyPress}
            InputProps={{
              type: 'number',
              startAdornment: <InputAdornment position="start"></InputAdornment>,
              inputRef: inputRef,
              sx: {
                '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
                  WebkitAppearance: 'none',
                  margin: 0
                }
              }
            }}
            
          />
        </DialogContent>
        <DialogActions>
          <Button
            className="w-1/2 h-10"
            variant="outlined"
            color="secondary"
            onClick={handleMfaCancel}
            sx={{ marginTop: 3 }}
          >
            {t("confirm_mfa_cancel")}
          </Button>
          <Button
            className="w-1/2 h-10"
            variant="contained"
            color="primary"
            onClick={onConfirm}
            sx={{ marginTop: 3 }}
          >
            {t("confirm_mfa")}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default MfaVerify;
